module.exports = require("core-js/modules/es.string.from-code-point.js");